import './thumbnail.scss';
import './thumbnail-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/thumbnail/index.js